import { useState } from 'react';
import { Translate } from '~/i18n';
import { reportAbuse } from '~/apis/reviews/report-abuse.api';
import { SubmitLoader } from '~/components/common/loaders/submit';
import { Button } from '~/components/common/button';
import Modal from '~/components/common/modal';
import { Section } from '~/components/common/section';
import { WarningOutlineIcon } from '~/svgs/marketplace';
import { successMessage, errorMessage } from '~/utils/toasts';

type ReportAbusePopupProps = {
   open: boolean;
   reportData: any;
   onClose: () => any;
   onConfirm: () => any;
};
const ReportAbusePopup = ({ open, reportData, onClose, onConfirm }: ReportAbusePopupProps) => {
   const [loading, setLoading] = useState(false);

   const confirmHandler = async () => {
      try {
         setLoading(true);
         const { response, error } = await reportAbuse({
            review_id: reportData?.review_id,
            reported_message: 'Reported abuse comment',
         });
         if (error) {
            errorMessage(error.response?.data?.message, 4000);
            setLoading(false);
         }
         if (response) {
            if (response.status === 'Success') {
               successMessage('Reported Successfully');
            }
         }
         onConfirm();
      } catch (error: any) {
         console.info(error);
         errorMessage(error.response?.data?.message, 4000);
         setLoading(false);
         onConfirm();
      }
   };

   return (
      <Modal size="xs" open={open}>
         <Modal.Body>
            <Section className="p-2 rounded-xl">
               <div className="flex flex-col items-center p-10 text-center space-y-4">
                  <WarningOutlineIcon width={40} height={40} className="[&>*]:fill-red" />
                  <div className="my-2 text-2xl font-bold">
                     <Translate id="reviews:report abusive comment" />
                  </div>
                  <div className="text-sm">
                     <Translate id="reviews:are you sure you want to continue" />
                  </div>
               </div>
               <div className="flex justify-between p-4">
                  <Button
                     onClick={() => onClose()}
                     className="!w-1/2 h-12 !border-1 !font-normal !border-grey-200 !text-grey-200">
                     <Translate id="common:cancel" />
                  </Button>
                  <Button
                     disabled={loading}
                     type="button"
                     theme="primary"
                     className="!w-1/2 !font-normal ml-2 h-12 !bg-orange"
                     onClick={() => confirmHandler()}>
                     {loading ? (
                        <SubmitLoader isDotsType color="#ffffff" />
                     ) : (
                        <Translate id="common:yes" />
                     )}
                  </Button>
               </div>
            </Section>
         </Modal.Body>
      </Modal>
   );
};

export default ReportAbusePopup;
